function updateSizeLegendsAndStyles() {
  const urlParams = new URLSearchParams(window.location.search);
  const variantIdFromUrl = urlParams.get("variant");

  if (!variantIdFromUrl) {
    const variantLegends = document.querySelectorAll("[data-variant-legend]");
    const sizeVariantLegends = Array.from(variantLegends).filter((legend) => {
      const legendText = legend.textContent.toLowerCase();
      return legendText.includes("a/b") || legendText.includes("a-d") || legendText.includes("ab-c");
    });

    sizeVariantLegends.forEach((legend) => {
      legend.textContent = "Select Your Size";
    });

    const checkedRadios = document.querySelectorAll(
      '.product-form__input input[type="radio"]:checked + label'
    );
    checkedRadios.forEach((label) => {
      const legendText = label.textContent.toLowerCase();
      if (legendText.includes("a/b") || legendText.includes("a-d") || legendText.includes("ab-c")) {
        label.classList.add("custom-radio-label");

        label.previousElementSibling.addEventListener("change", () => {
          if (label.classList.contains("custom-radio-label")) {
            label.classList.remove("custom-radio-label");
          }
        });
      }
    });
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", updateSizeLegendsAndStyles);
} else {
  updateSizeLegendsAndStyles();
}

// ========= Part 3: Custom Variant Validation Script (Start) ===========

document.addEventListener("DOMContentLoaded", function () {
  const productForms = document.querySelectorAll(
    'form[id^="product-form-template--"]'
  );

  productForms.forEach((form) => {
    const addToCartButton = form.querySelector(".product-form__submit");
    const variantRadios = form.querySelectorAll(
      'input[type="radio"][name^="Size"]'
    );
    const variantIdInput = form.querySelector('input[name="id"]');

    if (!addToCartButton || !variantRadios || !variantIdInput) return;

    const urlParams = new URLSearchParams(window.location.search);
    const variantIdFromUrl = urlParams.get("variant");

    if (variantIdFromUrl) {
      const preselectedRadio = form.querySelector(
        `input[type="radio"][name^="Size"][value="${variantIdFromUrl}"]`
      );
      if (preselectedRadio) {
        preselectedRadio.checked = true;
        const variantSelectElement = preselectedRadio.closest("variant-radios");
        if (variantSelectElement) {
          variantSelectElement.toggleAddButton(false);
        }
      }
    } else {
      addToCartButton.setAttribute("disabled", "disabled");
      if (this && this.dataset && this.dataset.variantId) {
          variantIdInput.value = this.dataset.variantId;
        }
    }

    variantRadios.forEach((radio) => {
      radio.addEventListener("change", function () {
        variantIdInput.value = this.value;
        const variantSelectElement = radio.closest("variant-radios");
        if (variantSelectElement) {
          variantSelectElement.toggleAddButton(false);
        }
      });
    });
  });
});

// ========= Custom Variant Validation Script (End) ===========

let firstClickHandled = false;

document.addEventListener("click", function (event) {
  if (!firstClickHandled) {
    const targetRadio = event.target.closest('input[type="radio"]');

    if (targetRadio) {
      const addToCartButton = document.querySelector(".product-form__submit");

      const sizeLegend = targetRadio
        .closest(".product-form__input")
        .querySelector("[data-variant-legend]");
      const radioGroupName = targetRadio.name.toLowerCase();
      if (
        sizeLegend &&
        (radioGroupName === "size - tights" ||
          radioGroupName === "size - clothing")
      ) {
        sizeLegend.textContent = targetRadio.value;
      }

      addToCartButton.disabled = false;

      const radioLabels = document.querySelectorAll('.product-form__input input[type="radio"] + label');
      radioLabels.forEach((label) => {
        label.classList.remove("custom-radio-label");
      });

      firstClickHandled = true;
    }
  }
});
